import { render } from "./AddEditTeacher.vue?vue&type=template&id=e495704c&scoped=true"
import script from "./AddEditTeacher.vue?vue&type=script&lang=js"
export * from "./AddEditTeacher.vue?vue&type=script&lang=js"

import "./AddEditTeacher.vue?vue&type=style&index=0&id=e495704c&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e495704c"]])

export default __exports__